import React, { useEffect, useState } from "react";
import { Box, Checkbox, Chip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import TextField from "components/TextField";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface ProductionParksSelectProps {
  productionParks: any[];
  selectedProductionParks?: { title: string; value: number }[];
  setSelectedProductionParks?: (
    productionParks: { title: string; value: number }[],
  ) => void;
  formValues?: any;
  setFormValues?: React.Dispatch<React.SetStateAction<any>>;
  minWidth?: number;
  maxWidth?: number;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

const ProductionParksSelect: React.FC<ProductionParksSelectProps> = ({
  productionParks,
  selectedProductionParks,
  setSelectedProductionParks,
  formValues,
  setFormValues,
  minWidth = 480,
  maxWidth = 480,
  label = "Production parks",
  placeholder = "Select production parks",
  disabled,
}) => {
  const [productionParkOptions, setProductionParkOptions] = useState<
    { title: string; value: number }[]
  >([]);

  useEffect(() => {
    if (productionParks) {
      const productionParkOptionsCopy = productionParks.map((ss) => {
        return { title: ss.label, value: ss.value };
      });

      setProductionParkOptions(productionParkOptionsCopy);
    }
  }, [productionParks]);

  const handleSelectProductionPark = (option: {
    title: string;
    value: number;
  }) => {
    let selectedProductionParksData = [...selectedProductionParks];

    if (!!selectedProductionParks.find((sc) => sc.value === option.value)) {
      selectedProductionParksData = selectedProductionParksData.filter(
        (sc) => sc.value !== option.value,
      );
    } else {
      selectedProductionParksData = [...selectedProductionParksData, option];
    }

    setSelectedProductionParks(selectedProductionParksData);
    if (setFormValues) {
      setFormValues({
        ...formValues,
        selectedProductionParks: selectedProductionParksData,
      });
    }
  };

  const handleRemoveSelectedProductionPark = (option: {
    title: string;
    value: number;
  }) => {
    let selectedProductionParksData = [...selectedProductionParks];
    selectedProductionParksData = selectedProductionParksData.filter(
      (sc) => sc.title !== option.title,
    );
    setSelectedProductionParks(selectedProductionParksData);
    if (setFormValues) {
      setFormValues({
        ...formValues,
        selectedProductionParks: selectedProductionParksData,
      });
    }
  };

  return (
    <Box sx={{ mr: "0.5rem" }}>
      <Autocomplete
        multiple
        id="selectedProductionParks"
        value={selectedProductionParks}
        limitTags={2}
        disabled={disabled}
        disableCloseOnSelect
        renderTags={(value, getTagProps) =>
          value?.map((option, index) => {
            const { key } = getTagProps({ index });
            return (
              <Chip
                label={option.title}
                key={key}
                onDelete={() => handleRemoveSelectedProductionPark(option)}
                size="small"
                sx={{ mr: "4px", mb: "4px" }}
              />
            );
          })
        }
        options={productionParkOptions || []}
        getOptionLabel={(option) => option.title}
        defaultValue={[]}
        size="small"
        renderInput={(params) => (
          <TextField
            id="productionPark"
            params={params}
            minWidth={minWidth}
            maxWidth={maxWidth}
            label={label}
            placeholder={placeholder}
          />
        )}
        renderOption={(props, option) => {
          const isSelected = !!selectedProductionParks.find(
            (sc) => sc.value === option.value,
          );

          return (
            <li
              {...props}
              style={{ padding: "0rem" }}
              onClick={() => handleSelectProductionPark(option)}
            >
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 4 }}
                checked={isSelected}
              />
              {option.title}
            </li>
          );
        }}
      />
    </Box>
  );
};

export default ProductionParksSelect;
